import { Button } from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import { rhythm } from 'Themes/typography';
import React from 'react';
import styled from 'styled-components';

import ClearFile from '../components/ClearFile';
import FieldError from '../components/FieldError';

const Explanation = styled.p`
  padding-top: 3px;
  color: ${({ theme }) => theme.palette.blue.main};
`;

const Container = styled.div`
  padding: ${rhythm(1.5)} 0 ${rhythm(5.5)};
  height: 100%;
  // border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
`;

const Heading = styled.h1`
  font-size: 1rem;
`;

const CustomButton = styled.div`
  &&& {
    background: #fff;
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    font-weight: 600;
    font-size: 1rem;
    text-transform: uppercase;
    position: relative;

    color: ${({ disabled }) =>
      disabled ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 0.87)'};
    padding: 6px 16px;
    min-width: 64px;
    box-sizing: border-box;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    line-height: 1.75;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    border-radius: 4px;
    letter-spacing: 0.02857em;
    text-align: center;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
    cursor: pointer;

    &:hover {
      background-color: #ffca28 !important;
    }
  }
`;

const FileInput = styled.input.attrs({
  type: 'file',
  size: 5242880,
  accept: `.ies, .ldt, .t14, .uld, .dwg, .dxf, .rvt, .dgn, .3dm`,
})`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 0;
`;

const File = styled.div`
  display: inline-flex;
  align-items: center;
`;

const FileName = styled.span`
  font-size: 0.875rem;
  margin-left: 0.5rem;
`;
const FileContainer = styled.div`
  padding: 1.5625rem 0 0;
`;

// TODO: this component is used in multiple places, refactor into global
class IESUpload extends React.PureComponent {
  render() {
    const {
      iesInputRef,
      onAddIESFile,
      onIESFileRemove,
      ies,
      error,
    } = this.props;
    return (
      <Container>
        <Heading>
          <div>Add photometric data or CAD file</div>
          {error && <FieldError>{`*${error}`}</FieldError>}
        </Heading>
        <CustomButton disabled={Boolean(ies) ? true : false}>
          <FileInput
            onChange={onAddIESFile}
            innerRef={iesInputRef}
            disabled={Boolean(ies) ? true : false}
          />
          upload data file
        </CustomButton>
        <Explanation>
          The file cannot exceed 5MB. Supported file types: ies, ldt, t14, uld,
          dwg, dxf, rvt, dgn, 3dm.
        </Explanation>
        <FileContainer>
          {Boolean(ies) && (
            <File>
              <FileCopy />
              <FileName>{ies.name}</FileName>
              <ClearFile onClick={onIESFileRemove('ies')} />
            </File>
          )}
        </FileContainer>
      </Container>
    );
  }
}

export default IESUpload;
